import axios from 'axios';
import i18n from '@/ui/i18n';

const country = i18n.locale;

const mapConfigURLs = {
  cl: process.env.VUE_APP_BACKEND_URL_CL,
  br: process.env.VUE_APP_BACKEND_URL_BR,
  pe: process.env.VUE_APP_BACKEND_URL_PE
};

const CONFIG = {
  timeout: 30000,
  baseURL: mapConfigURLs[country], // process.env.VUE_APP_BACKEND_URL,
  contentType: 'application/json'
};

// simulator-backend
const mapConfigSimulatorBackendURLs = {
  cl: process.env.VUE_APP_SIMULATOR_BACKEND_CL,
  br: process.env.VUE_APP_SIMULATOR_BACKEND_BR,
  pe: process.env.VUE_APP_SIMULATOR_BACKEND_PE
};

const SIMULATOR_BACKEND_CONFIG = {
  timeout: 30000,
  baseURL: mapConfigSimulatorBackendURLs[country],
  contentType: 'application/json'
};
// !simulator-backend
// evaluations
const mapConfigEvaluationsURLs = {
  cl: process.env.VUE_APP_EVALUATIONS_CL,
  br: process.env.VUE_APP_EVALUATIONS_BR
};
const mapConfigGatewayUrl = {
  cl: process.env.VUE_APP_GATEWAY_URL
};
const mapConfigRiskPolicyUrl = {
  cl: process.env.VUE_APP_RISKPOLICY_CL,
  pe: process.env.VUE_APP_RISKPOLICY_PE,
  br: process.env.VUE_APP_RISKPOLICY_BR
};

const EVALUATIONS_CONFIG = {
  timeout: 30000,
  baseURL: mapConfigEvaluationsURLs[country],
  contentType: 'application/json'
};

const ELIGIBILITY_CONFIG = {
  timeout: 30000,
  baseURL: mapConfigGatewayUrl[country],
  contentType: 'application/json'
};

const RISKPOLICY_CONFIG = {
  timeout: 30000,
  baseURL: mapConfigRiskPolicyUrl[country],
  contentType: 'application/json'
};

const FINANCIAL_DATA_VERIFICAROR_CONFIG = {
  timeout: 30000,
  baseURL: mapConfigGatewayUrl[country],
  contentType: 'application/json'
};

// !simulator-backend
const mapFunnelURLs = {
  cl: process.env.VUE_APP_FUNNEL_URL_CL,
  br: process.env.VUE_APP_FUNNEL_URL_BR,
  pe: process.env.VUE_APP_FUNNEL_URL_PE
};

const FUNNEL = {
  timeout: 120000,
  baseURL: mapFunnelURLs[country], // process.env.VUE_APP_FUNNEL_URL,
  contentType: 'application/json'
};

const FUNNELCL = {
  timeout: 120000,
  baseURL: mapFunnelURLs.cl, // process.env.VUE_APP_FUNNEL_URL,
  contentType: 'application/json'
};

const FUNNELPE = {
  timeout: 120000,
  baseURL: mapFunnelURLs.pe, // process.env.VUE_APP_FUNNEL_URL,
  contentType: 'application/json'
};

const FUNNELBR = {
  timeout: 120000,
  baseURL: mapFunnelURLs.br, // process.env.VUE_APP_FUNNEL_URL,
  contentType: 'application/json'
};

const CONFIG_EXTERNAL_API = {
  timeout: 30000,
  contentType: 'application/json'
};

const CONFIG_QUERY_STACK = {
  timeout: 30000,
  baseURL: process.env.VUE_APP_EVENT_QUERY_STACK_URL,
  contentType: 'application/json'
};

const CONFIG_API_GATEWAY = {
  timeout: 30000,
  baseURL: process.env.VUE_APP_API_GATEWAT_URL,
  contentType: 'application/json'
};

const CONFIG_REAL_ESTATE = {
  timeout: 30000,
  baseURL: process.env.VUE_APP_REAL_ESTATE_URL,
  contentType: 'application/json'
};

// create axios instances
const request = axios.create(CONFIG);
const externalRequest = axios.create(CONFIG_EXTERNAL_API);
const simulatorBackend = axios.create(SIMULATOR_BACKEND_CONFIG);
const evaluationsBackend = axios.create(EVALUATIONS_CONFIG);
const eligibilityBackend = axios.create(ELIGIBILITY_CONFIG);
const requestRiskPolicies = axios.create(RISKPOLICY_CONFIG);
const financialDataVerificator = axios.create(FINANCIAL_DATA_VERIFICAROR_CONFIG);
const requestFunnel = axios.create(FUNNEL);
// Baypass momentaneo para que Javier pueda clonar los permisos de usuario entre países.
const requestFunnelCL = axios.create(FUNNELCL);
const requestFunnelBR = axios.create(FUNNELBR);
const requestFunnelPE = axios.create(FUNNELPE);
const requestQueryStack = axios.create(CONFIG_QUERY_STACK);
const requestAPIGateway = axios.create(CONFIG_API_GATEWAY);
const requestRealEstate = axios.create(CONFIG_REAL_ESTATE);

export {
  request,
  externalRequest,
  simulatorBackend,
  evaluationsBackend,
  requestFunnel,
  requestFunnelCL,
  requestFunnelBR,
  requestFunnelPE,
  requestQueryStack,
  requestAPIGateway,
  requestRealEstate,
  requestRiskPolicies,
  eligibilityBackend,
  financialDataVerificator
};
